import { colors, IStyles } from 'theme'

export const defaultThemeStyles: IStyles = {
    separator: colors.cloud,
    iconBackground: colors.white,
}
